// @flow

import * as React from 'react';

import { useSelector } from 'react-redux';
import { superpathjoin } from 'superpathjoin';

import {
  useTranslator,
  localeSelector as selectLocale,
} from '@gandi/translate';
import { Cell } from '@gandi/ui';
import { ListIcon, ListItem } from '@gandi/ui/deprecated';

import { selectLoginEndpoint, selectShopURL } from '../../../modules/config';

import styles from './LoginRow.scss';

function LoginRow(): React.MixedElement {
  const { __ } = useTranslator();
  const locale = useSelector(selectLocale);
  const loginEndpoint = useSelector(selectLoginEndpoint);

  const shopURL = useSelector(selectShopURL);

  const renewHref = superpathjoin(shopURL, 'domain', 'renew');

  const encodedRenewHref = encodeURIComponent(renewHref);

  const href = `${loginEndpoint}/${locale}/login?redirect=${encodedRenewHref}`;

  return (
    <ListItem>
      <ListIcon name="bell" className={styles.icon} />
      <Cell flex flexGrow1 paddingLeft="none">
        <span
          dangerouslySetInnerHTML={__(
            'You can <a href=%(href)s>login</a> to see which of your products' +
              ' need to be renewed now.',
            {
              withHTML: true,
              // XXX: what if undefined?
              href,
            },
          )}
        />
      </Cell>
    </ListItem>
  );
}

export default LoginRow;
